<div class="legal-page">
  <div class="legal-page__container">
    <h1>Privacy Policy</h1>
    <p>Last updated: [date]</p>

    <h2>1. Information We Collect</h2>
    <p>
      We collect information you provide directly to us, such as your account details, and information
      collected automatically when you use the platform, such as usage data.
    </p>

    <h2>2. How We Use Your Information</h2>
    <p>
      We use the information we collect to operate, maintain, and improve the platform, to communicate
      with you, and to personalise your experience.
    </p>

    <h2>3. Data Sharing</h2>
    <p>
      We do not sell your personal information. We may share information with service providers who
      assist us in operating the platform, and where required by law.
    </p>

    <h2>4. Data Security</h2>
    <p>
      We take reasonable measures to protect your information from loss, theft, misuse, and unauthorised
      access, disclosure, alteration, and destruction.
    </p>

    <h2>5. Your Rights</h2>
    <p>
      You may access, update, correct, or delete your personal information, and you may object to or
      restrict certain processing of your data.
    </p>

    <h2>6. Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. We will notify you of any material changes by
      posting the new policy on this page.
    </p>
  </div>
</div>
